import { render, staticRenderFns } from "./McnTaskFans.vue?vue&type=template&id=ace5afc0&scoped=true"
import script from "./McnTaskFans.vue?vue&type=script&lang=js"
export * from "./McnTaskFans.vue?vue&type=script&lang=js"
import style0 from "./McnTaskFans.vue?vue&type=style&index=0&id=ace5afc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace5afc0",
  null
  
)

export default component.exports